import { render, staticRenderFns } from "./BookingDetailsPopup.vue?vue&type=template&id=a38c58be&"
import script from "./BookingDetailsPopup.vue?vue&type=script&lang=js&"
export * from "./BookingDetailsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports